import axios from '../utils/axios';

export default function getLastActiveSubscription(adminId, params) {
    return axios
        .get(`/admin/${adminId}/jobseeker-admin/user/admin/last-subscription`, { params })
        .then(response => {
            // Map the new response structure to match the old structure
            if (response.data && response.data.data && response.data.data.data) {
                return {
                    plan: {
                        id: response.data.data.data.id,
                        orderid: response.data.data.data.orderId,
                        product_id: response.data.data.data.productId,
                        start_date: response.data.data.data.startDate,
                        end_date: response.data.data.data.endDate
                    }
                };
            }
            return {};
        })
        .catch(err => {
            return {};
        });
}